import {
    availableTimeConstants,
    createLeaveDayConstants,
    employeeAndManagerLeaderConstants,
    leaveTypesConstants,
} from "../constant/newLeaveRequest.constants";

export const initialState = {
    listEmployee: [],
    listManagerLeader: [],
    listLeaveType: [],
    listAvailableTime: [],
    errorCode: "",
    successCode: "",
    submitting: false,
};

const newLeaveRequestReducer = (state = initialState, action) => {
    switch (action.type) {
        case employeeAndManagerLeaderConstants.GET_SUCCESS:
            return {
                ...state,
                listEmployee: action.listEmployeeAndManagerLeader.listEmployeeSelectBox,
                listManagerLeader: action.listEmployeeAndManagerLeader.listManagerLeaderBox,
            };
        case employeeAndManagerLeaderConstants.GET_FAILURE:
            return {
                ...state,
                errorCode: action.error,
            };
        case leaveTypesConstants.GET_SUCCESS:
            return {
                ...state,
                listLeaveType: action.listLeave.listLeaveTypeSelectBox,
            };
        case leaveTypesConstants.GET_FAILURE:
            return {
                ...state,
                errorCode: action.error,
            };
        case availableTimeConstants.GET_SUCCESS:
            return {
                ...state,
                listAvailableTime: action.listAvailable,
            };
        case availableTimeConstants.GET_FAILURE:
            return {
                ...state,
                listAvailableTime: action.listAvailableTime,
            };
        case availableTimeConstants.DELETE:
            return {
                ...state,
                listAvailableTime: action.dataAailableTime,
            };
        case createLeaveDayConstants.ADD_SUCCESS:
            return {
                ...state,
                submitting: true,
                successCode: action.code,
            };
        case createLeaveDayConstants.ADD_FAILURE:
            return {
                ...state,
                submitting: false,
                errorCode: action.error,
            };
        case createLeaveDayConstants.DELETE:
            return {
                ...state,
                submitting: false,
                errorCode: action.error,
            };
        case createLeaveDayConstants.ADD_LOADING:
            return {
                ...state,
                submitting: true,
            };
        default:
            return {
                ...state,
            };
    }
};

export default newLeaveRequestReducer;
